// SkyBattleSea — Engine Range Game bootstrap.
// BUILD is read by scripts/android_version.mjs and scripts/publish_apk.sh; keep the exact form.
import { initNative } from './native';
import { mountApp } from './range/ui/app';

const BUILD = 'v1.1.0';

initNative();
const root = document.getElementById('app');
if (root) mountApp(root, BUILD);
